export const DEFAULT_MIN_CELL_WIDTH = 150;
